import React, {Component, Fragment} from 'react';
import {getData, postData, uploadFile} from "../../api/doLogin";
import {Button, Card, CardBody, CardHeader, FormGroup, Input, Label} from "reactstrap";
import FileEntry from "./entry/FileEntry";
import {MakeDialog} from "../../components/Shared/MakeDialog";
import {EventClient} from "../../util/eventClient";
import BriefcaseEntryEditor from "./views/BriefcaseEntryEditor";
import {extractNumber} from "../../util/numberhelpers";
import {checkPerms, RequiredPermissions} from "../../api/permissions";
import Dropzone from "react-dropzone";
import {toast} from "react-toastify";
import {getFormFieldValue} from "../Applications/shared/shared";
import BriefcaseFolderSelection from "./modals/BriefcaseFolderSelection";
import {NewBreadcrumb} from "../../components/Breadcrumb/NewBreadcrumb";
import {PromptDialog} from "../Shared/PromptDialog";

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

export default class Briefcase extends Component {
  constructor(props) {
    super(props);

    // this.curTaxYear = new Date().getUTCFullYear() - 1;
    this.state = {
      data: {},
      folders: [],
      files: [],
      breadcrumbs: [],
      dataLoaded: true,
      intakeStatus: 0,
      uploadedDocuments: false,
      downloadDocuments: false,
      gotoIntakeUUID: "",
      calendar: [],
      cameras: [],
      calendarList: [],
      banners: [],
      folderName: "",
      filesLoading: false,
      showCreateFolder: false,
      showCheck: false,
      fullView: false,
      inCallback: false,
      checked: {
        folders: [],
        files: []
      },
      selectionMode: null,
      showRename: false,
      depth: -1,
    };
    this.acceptedMimes = ["image/jpeg", "image/png", "image/gif", "application/pdf"];
  }

  componentWillMount() {
    EventClient.on('BRIEFCASE_REFRESH', (data) => this.getFolder(data, this.props.match.params.agency_id || this.props.agency_id || 0, this.props.match.params.month || this.props.month || 0), "Briefcase");

  }

  componentWillUnmount() {
    EventClient.off('BRIEFCASE_REFRESH', (data) => this.getFolder(data), "Briefcase");
  }

  componentDidMount() {
    this.getFolder(this.props.match.params.folder_id || this.props.folder_id || 0);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (this.props.match.params.folder_id !== nextProps.match.params.folder_id) {
      return this.getFolder(nextProps.match.params.folder_id || nextProps.folder_id || 0, nextProps.match.params.agency_id || nextProps.agency_id || 0, nextProps.match.params.month || nextProps.month || 0);
    }
    if (this.props.match.params.agency_id !== nextProps.match.params.agency_id) {
      return this.getFolder(nextProps.match.params.folder_id || nextProps.folder_id || 0, nextProps.match.params.agency_id || nextProps.agency_id || 0, nextProps.match.params.month || nextProps.month || 0);
    }
    if (this.props.match.params.month !== nextProps.match.params.month) {
      return this.getFolder(nextProps.match.params.folder_id || nextProps.folder_id || 0, nextProps.match.params.agency_id || nextProps.agency_id || 0, nextProps.match.params.month || nextProps.month || 0);
    }
    if (this.props.folder_id !== nextProps.folder_id) {
      return this.getFolder(nextProps.match.params.folder_id || nextProps.folder_id || 0, nextProps.match.params.agency_id || nextProps.agency_id || 0, nextProps.match.params.month || nextProps.month || 0);
    }
    if (this.props.agency_id !== nextProps.agency_id) {
      return this.getFolder(nextProps.match.params.folder_id || nextProps.folder_id || 0, nextProps.match.params.agency_id || nextProps.agency_id || 0, nextProps.match.params.month || nextProps.month || 0);
    }
    if (this.props.month !== nextProps.month) {
      return this.getFolder(nextProps.match.params.folder_id || nextProps.folder_id || 0, nextProps.match.params.agency_id || nextProps.agency_id || 0, nextProps.match.params.month || nextProps.month || 0);
    }
  }

  getFolder(folder_id = 0, agency_id = 0, month = 0) {
    let self = this;
    this.setState({filesLoading: true});
    let url = `briefcase/${folder_id}`;
    if (String(folder_id) === "-2") url += `/callback`;
    if (agency_id && Number(agency_id) > 0) {
      url += `/${agency_id}`;
    } else if (agency_id && Number(agency_id) > 0) {
      url += `/${agency_id}`;
    }
    if (month && Number(month) > 0) {
      url += `/${month}`;
    } else if (month && Number(month) > 0) {
      url += `/${month}`;
    }
    getData(url, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          let curState = this.state;
          if (typeof data.data['folders'] === "object") {
            curState['folders'] = data.data.folders;
          } else {
            curState['folders'] = [];
          }
          if (typeof data.data['files'] === "object") {
            curState['files'] = data.data.files;
          } else {
            curState['files'] = [];
          }
          if (typeof data.data['breadcrumbs'] === "object") {
            curState['breadcrumbs'] = data.data.breadcrumbs;
          } else {
            curState['breadcrumbs'] = [];
          }
          if (data.data['callbackFolder'] === true) {
            curState['folders'].push({
              "id": -2,
              "pid": 0,
              "display": "Callback"
            })
          }
          if (data.data['depth'] !== undefined) {
            curState['depth'] = data.data.depth;
          } else {
            curState['depth'] = -1;
          }
          // if (typeof data.data['cameras'] === "object") {
          //   curState['cameras'] = data.data.cameras;
          // }
          // if (typeof data.data['calendarList'] === "object") {
          //   curState['calendarList'] = data.data.calendarList;
          // }
          // if (typeof data.data['banners'] === "object") {
          //   curState['banners'] = data.data.banners;
          // }
          //console.log(curState);
          if (folder_id === -2) {
            curState['inCallback'] = true;
          } else {
            curState['inCallback'] = false;
          }
          curState.dataLoaded = true;
          curState.filesLoading = false;
          self.setState(curState);
        }
      }) // JSON-string from `response.json()` call
      .catch(error => {
        console.error(error)
        //self.setState({errorMsg:error,isProcessing:false});
      });
  }

  dropError(context, error) {
    //alert('Error');
  }

  makeFolder() {
    const self = this;
    self.setState({filesLoading: true});
    postData(`briefcase/${this.props.match.params.folder_id || this.props.folder_id}/mkdir`, {folderName: this.state.folderName}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          // console.log(data.data);
          // EventClient.emit("NAVIGATE", `/briefcase/${this.props.folderId || 0}`);
          self.setState({showCreateFolder: false, folderName: ""}, () => {
            EventClient.emit("BRIEFCASE_REFRESH", self.props.match.params.folder_id || self.props.folder_id || 0);
          });
        } else {
          // console.log(data.message, data.data);
          toast.error(data.message);
          self.setState({filesLoading: false});
        }
      }).catch((error) => {
      console.log(error);
      toast.error("Could not create Folder");
      self.setState({filesLoading: false});
    });
  }

  onDrop(acceptedFiles, rejectedFiles) {
    var self = this;
    this.setState({
      dropzoneActive: false,
      filesLoading: true
    });
    //console.log(acceptedFiles);
    //console.log(rejectedFiles);
    let req = new FormData;
    acceptedFiles.forEach(file => {
      req.append('file', file);
    });
    req.append('action', 'UploadFile');
    // req.append('folderId', "0");
    uploadFile(`briefcase/${this.props.match.params.folder_id || this.props.folder_id}/add`, req, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          // console.log(data.data);
          toast.success('File(s) Uploaded Successfully');
          // self.updateData();
          EventClient.emit("BRIEFCASE_REFRESH", self.props.match.params.folder_id || self.props.folder_id || 0);
        } else {
          toast.error("Error " + data.message);
          self.setState({
            filesLoading: false
          });
        }
      })
      .catch(error => {
        self.setState({
          filesLoading: false
        });
        console.error(error);
      });
  }

  onDragEnter() {
    // this.setState({
    //   dropzoneActive: true
    // });
  }

  onDragLeave() {
    // this.setState({
    //   dropzoneActive: false
    // });
  }

  handleFolderClick(id, extra, depth) {
    if (this.state.showCheck) {
      const folders = this.state.checked.folders;
      if (folders.indexOf(id) > -1) {
        folders.splice(folders.indexOf(id), 1);
      } else {
        folders.push(id);
      }
      this.setState({checked: {...this.state.checked, folders: [...folders]}});
    } else {
      let url = `/briefcase${id !== "0" ? `/${id}` : ""}`
      if (String(this.props.folder_id) === "-2" && extra) {
        url = `/briefcase/${this.props.folder_id}`
      }
      if (extra && (extra.agency_id === 0)) {
        url += `/callback/${id}`
      } else if (extra && extra.agency_id) {
        url += `/callback/${extra.agency_id}`
      }
      if (depth === 3) {
        if (extra && extra.month === 0) {
          url += `/${id}`
        } else if (extra && extra.month) {
          url += `/${extra.month}`
        }
      }
      this.props.history.push(url)
    }
  }

  handleFileClick(id, extra) {
    if (this.state.showCheck) {
      const files = this.state.checked.files;
      if (files.indexOf(id) > -1) {
        files.splice(files.indexOf(id), 1);
      } else {
        files.push(id);
      }
      this.setState({checked: {...this.state.checked, files: [...files]}});
    } else {
      let url = `/briefcase/${this.props.match.params.folder_id || this.props.folder_id}`
      if (extra && extra.agency_id) url += `/callback/${extra.agency_id}`
      if (extra && extra.month) url += `/${extra.month}`
      this.props.history.push(`${url}/${id}`)
    }
  }

  hasSelected() {
    return this.hasFoldersSelected() || this.hasFilesSelected();
  }

  hasFoldersSelected() {
    return this.state.checked.folders.length > 0
  }

  hasMaxFoldersSelected(num) {
    return this.state.checked.folders.length === 1
  }

  hasFilesSelected() {
    return this.state.checked.files.length > 0
  }

  renameFolder(newName) {
    const self = this;
    const chosenFolder = this.state.folders.find((fold) => fold.id === this.state.checked.folders[0]);
    if (!chosenFolder) return EventClient.emit("TOAST_ERROR", "Error grabbing folder. Refresh and try again.");
    self.setState({filesLoading: true});
    postData(`briefcase/${chosenFolder.id}/rename`, {display: newName})
      .then((data) => {
        if (data.status === "Success") {
          // console.log(data.data);
          // EventClient.emit("NAVIGATE", `/briefcase/${this.props.folderId || 0}`);
          self.setState({showRenameFolder: false}, () => {
            EventClient.emit("BRIEFCASE_REFRESH", self.props.match.params.folder_id || self.props.folder_id || 0);
          });
        } else {
          // console.log(data.message, data.data);
          EventClient.emit("TOAST_ERROR", data.message);
          self.setState({filesLoading: false});
        }
      }).catch((error) => {
      console.log(error);
      EventClient.emit("TOAST_ERROR", "Could not rename Folder");
      self.setState({filesLoading: false});
    });
  }

  render() {
    const folder_id = this.props.match.params.folder_id || this.props.folder_id || "0";
    const file_id = this.props.match.params.file_id;
    const extra = {
      agency_id: (this.props.match.params.agency_id && Number(this.props.match.params.agency_id)) || this.props.agency_id,
      month: (this.props.match.params.month && Number(this.props.match.params.month)) || this.props.month
    }

    const extraBreadcrumb = (extra, index) => {
      if (index < 2) return null;
      if (index === 2) return {agency_id: extra.agency_id, month: 0};
      return extra;
    }

    return (
      <div className="animated fadeIn">
        {this.state.dataLoaded && (
          <Fragment>
            <Dropzone style={{width: '100%', border: '0px dashed'}}
                      accept={this.acceptedMimes.join(", ")}
                      disableClick
                      disabled={folder_id === "-2" || folder_id === "0"}
                      onDrop={(accepted, rejected) => this.onDrop(accepted, rejected)} maxSize={52428800}
                      onDragEnter={() => this.onDragEnter()} onDragLeave={() => this.onDragLeave()}>
              {({getRootProps, getInputProps, open}) => (
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <Card>
                    <CardHeader>
                      Briefcase - File Manager
                      <div className="card-actions">
                        <button
                          onClick={() => EventClient.emit("BRIEFCASE_REFRESH", this.props.match.params.folder_id || this.props.folder_id || 0)}
                          title={"Refresh Folder"}
                          key={"refresh"}
                        >
                          <small className="text-muted">
                            <i className="fa fa-refresh fa-lg" style={{position: "relative", fontSize: 25}}/>
                          </small>
                        </button>

                        {this.state.showCheck ?
                          <Fragment>
                            {this.hasSelected() && (
                              <Fragment>

                                {/*<button*/}
                                {/*  onClick={() => this.setState({selectionMode: "copy"})}*/}
                                {/*  title={"Copy To..."}*/}
                                {/*  style={{height: 45}}*/}
                                {/*  key={"copy"}*/}
                                {/*>*/}
                                {/*  <small className="text-muted">*/}
                                {/*    <i className="cil-clone" style={{fontSize: 30}}/>*/}
                                {/*  </small>*/}
                                {/*</button>*/}

                                <button
                                  onClick={() => this.setState({selectionMode: "move"})}
                                  title={"Move To..."}
                                  style={{height: 45}}
                                  key={"move"}
                                >
                                  <small className="text-muted">
                                    <i className="cil-input" style={{fontSize: 30}}/>
                                  </small>
                                </button>

                                {!this.hasFoldersSelected() && (

                                  <button
                                    onClick={() => this.setState({selectionMode: "copy"})}
                                    title={"Copy To..."}
                                    style={{height: 45}}
                                    key={"copy"}
                                  >
                                    <small className="text-muted">
                                      <i className="cil-copy" style={{fontSize: 30}}/>
                                    </small>
                                  </button>
                                )}

                                {this.hasMaxFoldersSelected(1) && !this.hasFilesSelected() && (
                                  <button
                                    onClick={() => this.setState({showRename: true})}
                                    title={"Rename..."}
                                    style={{height: 45}}
                                    key={"rename"}
                                  >
                                    <small className="text-muted">
                                      <i className="cil-pencil" style={{fontSize: 30}}/>
                                    </small>
                                  </button>
                                )}

                              </Fragment>
                            )}
                            <button
                              onClick={() => this.setState({showCheck: false, checked: {files: [], folders: []}})}
                              title={"Cancel Selection"}
                              style={{height: 45}}
                              key={"cancel"}
                            >
                              <small className="text-muted">
                                <i className="cil-x-circle" style={{fontSize: 30}}/>
                              </small>
                            </button>
                          </Fragment>
                          :
                          <Fragment>
                            {String(folder_id) !== "0" && String(folder_id) !== "-2" && (
                              <Fragment>

                                <button
                                  onClick={() => this.setState({folderName: "", showCreateFolder: true})}
                                  title={"Create Folder"}
                                  key={"mkdir"}
                                >
                                  <small className="text-muted">
                                    <div style={{position: "relative"}}>
                                      <i className="fa fa-plus-square fa-lg"
                                         style={{position: "absolute", top: 7, left: 18}}/>
                                      <i className="fa fa-folder-o fa-lg" style={{position: "relative", fontSize: 30}}/>
                                    </div>
                                  </small>
                                </button>

                                <button
                                  onClick={() => this.setState({showCheck: true})}
                                  title={"Select Entries"}
                                  style={{height: 45}}
                                  key={"select"}
                                >
                                  <small className="text-muted">
                                    <div style={{position: "relative", height: "100%"}}>
                                      <i className="cil-check-alt"
                                         style={{fontSize: 20, position: "absolute", left: 10, top: 0}}/>
                                      <i className="cil-check-alt"
                                         style={{fontSize: 20, position: "absolute", left: 11, top: 6}}/>
                                    </div>
                                  </small>
                                </button>

                                <button
                                  onClick={() => open()}
                                  title={"Upload File(s)"}
                                  key={"upload"}
                                >
                                  <small className="text-muted">
                                    <i className="fa fa-upload fa-lg" style={{position: "relative", fontSize: 30}}/>
                                  </small>
                                </button>

                              </Fragment>
                            )}
                          </Fragment>
                        }


                      </div>
                    </CardHeader>
                    <CardBody>
                      <NewBreadcrumb
                        crumbs={this.state.breadcrumbs}
                        extra={extra}
                        onClick={(id, index) => this.handleFolderClick(id, extraBreadcrumb(extra, index), index)}/>
                      <div style={{display: "inline-flex", flexWrap: "wrap"}}>
                        {this.state.breadcrumbs && this.state.breadcrumbs.length > 1 && (
                          <FileEntry id={this.state.breadcrumbs[this.state.breadcrumbs.length - 2].id} name={".."}
                                     type={"folder"}
                                     extra={extra}
                                     onClick={(type, id, extra) => !this.state.showCheck && this.handleFolderClick(id, extraBreadcrumb(extra, this.state.depth - 1), this.state.depth - 1)}/>
                        )}
                        {this.state.folders.map((folder, index) => {
                          return <FileEntry key={index} id={folder.id} name={folder.display}
                                            type={folder.pid === 0 ? "briefcase" : "folder"}
                                            extra={extra}
                                            showCheck={this.state.showCheck}
                                            checked={this.state.checked.folders.indexOf(folder.id) > -1}
                                            onClick={(type, id, extra) => this.handleFolderClick(id, extra, this.state.depth + 1)}/>
                        })}
                        {this.state.files.map((file, index) => {
                          return <FileEntry key={index} id={file.id} name={file.filename}
                                            type={"file"}
                                            status={file.status}
                                            extra={extra}
                                            entry={file}
                                            showCheck={this.state.showCheck}
                                            checked={this.state.checked.files.indexOf(file.id) > -1}
                                            onClick={(type, id, extra) => this.handleFileClick(id, extra)}/>
                        })}
                        {this.state.filesLoading && (
                          <div style={{
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            paddingTop: 100,
                            backgroundColor: "#fff",
                            opacity: 0.5,
                            top: 0,
                            left: 0
                          }}>
                            <div className="sk-double-bounce" style={{opacity: 1}}>
                              <div className="sk-child sk-double-bounce1"></div>
                              <div className="sk-child sk-double-bounce2"></div>
                            </div>
                          </div>
                        )}
                      </div>

                    </CardBody>
                  </Card>
                </div>
              )}
            </Dropzone>
          </Fragment>
        )}
        {!!file_id && (
          <MakeDialog isOpen={!!file_id}
                      hideHeader={this.state.fullView}
                      hideFooter={this.state.fullView}
                      size={this.state.fullView ? "fullscreen-modal" : undefined}
                      header="Briefcase File">
            <BriefcaseEntryEditor
              eventName="BriefcaseEntryEditor"
              saveEvent="BRIEFCASE_ENTRY_SAVE"
              deleteEvent="BRIEFCASE_ENTRY_DELETE"
              fullView={this.state.fullView}
              setFullView={(value) => this.setState({fullView: value})}
              // addSelection={this.state.addSelection}
              folderId={folder_id}
              onSave={() => {
                this.setState({fullView: false}, () => {
                  this.handleFolderClick(folder_id, extra, this.state.depth);
                  EventClient.emit("BRIEFCASE_REFRESH", folder_id);
                })
              }}
              token={this.props.token}
              onClose={() => {
                this.setState({fullView: false}, () => {
                  this.handleFolderClick(folder_id, extra, this.state.depth);
                })
              }}
              edit={extractNumber(file_id)}
              footer={(
                <Fragment>
                  <Button color="primary"
                          onClick={() => EventClient.emit("BRIEFCASE_ENTRY_SAVE", null)}>Save</Button>
                  {checkPerms(this.props.perms, RequiredPermissions.BriefcaseDelete) && (
                    <Button color="danger"
                            onClick={() => {
                              if (confirm('Are you sure you want to delete this file?')) {
                                EventClient.emit("BRIEFCASE_ENTRY_DELETE", null);
                              }
                            }}>Delete</Button>
                  )}
                  <Button color="secondary"
                          onClick={() => this.setState({fullView: false}, () => {
                            this.handleFolderClick(folder_id, extra, this.state.depth)
                          })}>Close</Button>
                </Fragment>
              )}/>
          </MakeDialog>
        )}
        <MakeDialog isOpen={this.state.showCreateFolder}
                    header={"Create Folder"}
                    footer={(
                      <Fragment>
                        <Button color="primary"
                                onClick={() => this.makeFolder()}>Create</Button>
                        <Button color="secondary"
                                onClick={() => this.setState({
                                  showCreateFolder: false,
                                  folderName: ""
                                })}>Close</Button>
                      </Fragment>
                    )}>
          <div>
            <FormGroup>
              <Label for="folderName">Folder Name</Label>
              <Input
                type="text"
                id="folderName"
                autoFocus
                value={getFormFieldValue(this.state['folderName'])}
                onChange={(evt) => this.setState({folderName: evt.target.value})}
              />
            </FormGroup>
          </div>
        </MakeDialog>

        {!!this.state.selectionMode && (
          <BriefcaseFolderSelection
            show={!!this.state.selectionMode}
            defaultFolder={folder_id}
            copyOrMove={this.state.selectionMode}
            files={this.state.checked.files}
            folders={this.state.checked.folders}
            onSuccess={() => {
              this.setState({selectionMode: null, showCheck: false, checked: {files: [], folders: []}}, () => {
                EventClient.emit("BRIEFCASE_REFRESH", folder_id);
              });
            }}
            onCancel={() => {
              this.setState({selectionMode: null});
            }}
          />
        )}

        {this.state.showRename && this.state.checked.folders.length === 1 && (
          <PromptDialog
            defaultValue={(this.state.folders.find((fold) => fold.id === this.state.checked.folders[0]) || {display: ""}).display}
            onSave={(value) => this.setState({showRename: false}, () => this.renameFolder(value))}
            onCancel={() => this.setState({showRename: false})}/>
        )}

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Briefcase/Briefcase.js